// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:ec1f1930-07d0-4a17-8e7d-fcc22981687c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_HsSNfWRsa",
    "aws_user_pools_web_client_id": "2ivapm4emm3hp9md9tk379a7eq",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://63e6tmgyknhsdds7czdnoq4c3u.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
};


export default awsmobile;
